import { render, staticRenderFns } from "./RflmTable.vue?vue&type=template&id=09bfbb9e"
import script from "./RflmTable.vue?vue&type=script&lang=ts"
export * from "./RflmTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports